<template>
    <div id="GpSelect">
        <div v-if="!loading">
            <div class="content-container back-button-container brand-primary animate__animated animate__fadeIn pb-5"
                v-if="selectedView !== 'bookingConfirm'">
                <span class="back-button" @click="goBack()"><i class="fa-solid fa-chevron-left"></i> Back </span>
            </div>
            <div class="gp-select-container mb-5 pb-5" ref="gpSelectTop">
                <div class="d-flex flex-column align-items-center content-container container-width w-100 animate__animated animate__fadeIn"
                    v-if="selectedView === 'appointmentType'">
                    <h3 class="pb-5 mb-3 brand-text align-self-center">What type of appointment would you like?</h3>
                    <b-button class="type-select-button shadow" id="select-video-appt-button"
                        @click="selectDeliveryType('video')">
                        <i class="fa-solid fa-circle-check pr-5"></i> Video call
                    </b-button>
                    <b-button class="type-select-button shadow" id="select-audio-appt-button"
                        @click="selectDeliveryType('phone')">
                        <i class="fa-solid fa-circle-check pr-5"></i> Audio call
                    </b-button>
                </div>
                <div class="d-flex flex-column align-items-center content-container container-width w-100 animate__animated animate__fadeIn"
                    v-if="selectedView === 'genderType'">
                    <h3 class="pb-5 mb-3 brand-text">Do you have a preference for who you see?</h3>
                    <b-button class="type-select-button shadow" id="select-any-appt-button"
                        @click="selectGenderType('a')">
                        <i class="fa-solid fa-circle-check pr-5"></i> No preference
                    </b-button>
                    <b-button class="type-select-button shadow" id="select-any-appt-button"
                        @click="selectGenderType('f')">
                        <i class="fa-solid fa-circle-check pr-5"></i> Female {{ apptTypeNames[$route.params.appt_type]
                        }}
                    </b-button>
                    <b-button class="type-select-button shadow" id="select-any-appt-button"
                        @click="selectGenderType('m')">
                        <i class="fa-solid fa-circle-check pr-5"></i> Male {{ apptTypeNames[$route.params.appt_type] }}
                    </b-button>
                </div>
                <div class="d-flex flex-column align-items-center content-container booking-container-width w-100 animate__animated animate__fadeIn"
                    v-if="selectedView === 'appointmentSelect'">
                    <div v-if="dates.length > 0" class="pb-3">
                        <h3 class="pb-4 brand-text">Choose your appointment</h3>
                    </div>
                    <div id="BookingSelection">
                        <div
                            class="content-container d-flex flex-column align-items-center animate__animated animate__fadeIn">
                            <div class="date-selector-container" v-if="dates.length > 0">
                                <slick ref="slickRef" class="slick-class" :options="slickOptions">
                                    <button
                                        class="date-select-button d-flex flex-column align-items-center justify-content-center"
                                        :disabled="buttonDisabled(date)" v-for="(date, i) in dates"
                                        :class="{ 'selected-date': getFormatedDate(selectedDate, 'L') === getFormatedDate(date, 'L') }"
                                        @click="selectDate(date)">
                                        <div>{{ getFormatedDate(date, 'ddd') }}</div>
                                        <div><b>{{ getFormatedDate(date, 'Do') }}</b></div>
                                        <div class="month-class">{{ getFormatedDate(date, 'MMM') }}</div>
                                    </button>
                                </slick>
                            </div>
                            <div v-if="dates.length > 0" class="mt-5">
                                <div class="pb-3">
                                    <h3 class="pb-4 brand-text">Filter by time of day</h3>
                                </div>
                                <b-button-group class="button-group">
                                    <b-button
                                        style="border-top-right-radius: 0 !important; border-bottom-right-radius: 0 !important;"
                                        size="lg" class="mb-0 left" @click="selectFilter('morning')" squared
                                        :variant="selectedFilter === 'morning' ? 'cta' : 'white'">AM</b-button>
                                    <b-button
                                        style="border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;"
                                        size="lg" class="mb-0 right" @click="selectFilter('evening')" squared
                                        :variant="selectedFilter === 'evening' ? 'cta' : 'white'">PM</b-button>
                                </b-button-group>
                            </div>
                            <div class="my-5" v-if="timeslotsLoading">
                                <b-spinner class="brand-primary" />
                            </div>
                            <div class="w-100" v-else>
                                <div class="w-100" v-if="filteredTimeslots.length === 0">
                                    <div class="date-selector-container my-5">
                                        <div class="available-times-header brand-text pb-0">
                                            <h3 class="pb-4 brand-text text-left">No appointments available that match
                                                your preferences.</h3>
                                            <p class="pb-0 mb-0">Try changing your selected date or selection
                                                preferences</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100" v-else>
                                    <div class="date-selector-container my-5">
                                        <div class="available-times-header brand-text">Available times</div>
                                        <div class="row" style="margin: 0 -5px;">
                                            <div class="col-6 col-sm-4 col-md-3 col-lg-2 px-1"
                                                v-for="(timeslot, i) in filteredTimeslots">
                                                <b-button class="my-2 timeslot-button w-100"
                                                    :variant="selectedTimeslot ? timeslot.id === selectedTimeslot.id ? 'cta' : 'cta-outline' : 'cta-outline'"
                                                    @click="selectTimeslot(timeslot)" squared>{{ timeslot.label
                                                    }}</b-button>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="text-center">
                                        <b-button variant="cta" size="lg" class="mx-auto py-4 px-5" squared
                                            :disabled="!selectedTimeslot" @click="viewPreview()">
                                            <span v-if="appointmentLoading"><b-spinner /></span><span v-else>Next</span>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column align-items-center content-container brand-text text-center animate__animated animate__fadeIn review-details"
                    v-if="selectedView === 'preview'">
                    <h3 class="brand-text pb-5">Check your booking details to make sure they are correct</h3>
                    <div
                        class="content-container text-prompt-container d-flex flex-column align-items-center animate__animated animate__fadeIn pb-5 w-100">
                        <div class="details-container">
                            <div class="details-row">
                                <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                                    <div class="details-row-title sentence-case">Clinician type</div>
                                </div>
                                <div>
                                    <div>{{ selectedTimeslot.appointment.Clinician.FullName }}</div>
                                </div>
                            </div>
                            <div class="details-row">
                                <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                                    <div class="details-row-title">Time</div>
                                </div>
                                <div>
                                    <div>{{ getFormatedDate(selectedTimeslot.id, 'h.mma') }}</div>
                                </div>
                            </div>
                            <div class="details-row">
                                <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                                    <div class="details-row-title">Date</div>
                                </div>
                                <div>
                                    <div>{{ getFormatedDate(selectedTimeslot.id, 'Do MMMM YYYY') }}</div>
                                </div>
                            </div>
                            <div class="details-row">
                                <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                                    <div class="details-row-title">Appointment type</div>
                                </div>
                                <div>
                                    <div>{{ selectedDeliveryType === 'video' ? 'Video' : 'Audio' }} call</div>
                                </div>
                            </div>
                            <div class="details-row" v-if="userDetails.symptoms">
                                <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                                    <div class="details-row-title">Your symptoms</div><span
                                        class="edit-button brand-primary" @click="editDetails()">Edit</span>
                                </div>
                                <div>
                                    {{ userDetails.symptoms }}
                                </div>
                            </div>
                            <div class="details-row" v-if="userDetails.symptoms_start_date">
                                <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                                    <div class="details-row-title">Symptoms start date</div><span
                                        class="edit-button brand-primary" @click="editDetails()">Edit</span>
                                </div>
                                <div v-if="symptomDate">
                                    {{ getFormatedDate(userDetails.symptoms_start_date, 'Do MMMM YYYY') }}
                                </div>
                            </div>
                            <div class="details-row" v-if="userDetails.symptoms">
                                <div class="d-flex flex-row justify-content-between align-items-center w-100 pb-3">
                                    <div class="details-row-title">Your photos</div><span
                                        class="edit-button brand-primary" @click="editDetails()">Edit</span>
                                </div>
                                <div class="d-flex flex-row justify-content-start align-items-center row mx-0"
                                    v-if="userDetails.photos.length > 0">
                                    <img class="img-fluid preview-image mr-3 mt-3" v-for="(i) in userDetails.photos"
                                        :src="i" />
                                </div>
                                <div v-else>
                                    No photos added
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content-container prompt-info-container d-flex flex-row justify-content-start align-items-start mb-4 border-brand-highlight-1"
                        v-if="false">
                        <i class="fa-solid fa-circle-exclamation fa-2x mr-4 brand-highlight-1"></i>
                        <div class="d-flex flex-column align-items-start">
                            <h3>Sharing information with Bupa insurance to check your cover</h3>
                            <p class="mb-0">If the clinician decides to refer you to a specialist, they'll send the
                                information
                                directly
                                to Bupa insurance.<br /><br />This means we can check that any recommended treatment is
                                covered.</p>
                        </div>
                    </div>
                    <div class="pb-5">
                        By booking an appointment, you agree to the following <a target="_blank"
                            href="https://www.bupa.co.uk/legal-notices/bupa-touch-terms-and-conditions/"
                            class="tc-link">terms
                            and conditions</a>.
                    </div>
                    <div>
                        <b-button variant="cta" id="book-now-button" size="lg" class="booking-button py-4"
                            :disabled="appointmentLoading" squared @click="createAppointment()">
                            <span v-if="!appointmentLoading">Book Now</span>
                            <span class="d-flex flex-row justify-content-center align-items-center" v-else><b-spinner
                                    style="width: 1.4rem; height: 1.4rem;" /></span>
                        </b-button>
                    </div>
                </div>
                <div class="d-flex flex-column align-items-center content-container  brand-text animate__animated animate__fadeIn booking-confirm-container"
                    v-if="selectedView === 'bookingConfirm'">
                    <div class="w-100 mb-5">
                        <div class="header-container">
                            <img src="/img/gp/confirm_icon.svg" class="confirm-icon" />
                            <h2>Your appointment is confirmed</h2>
                        </div>

                    </div>
                    <div class="column-row">
                        <div class="columns">
                            <div class="appointment-card bg-grey h-100">
                                <div class="d-flex flex-row justify-content-between align-items-center pb-3">
                                    <h3>{{ getFriendlyDateText(selectedTimeslot.id) }}</h3>
                                </div>
                                <div class="appointment-card-details">
                                    <h4 class="sentence-case">{{ bookedAppointmentType }} appointment
                                    </h4>
                                    <div><i class="fa-regular fa-user" /> {{
                                        selectedTimeslot.appointment.Clinician.FullName }}</div>
                                    <div><i class="fa-regular fa-clock" /> {{ getFormatedDate(selectedTimeslot.id,
                                        'h.mma') }} - {{ getEndTime(selectedTimeslot) }}
                                    </div>
                                    <div><i class="fa-regular fa-video" v-if="selectedDeliveryType === 'video'" /><i
                                            class="fa-regular fa-phone" v-else /> {{ selectedDeliveryType === 'video' ?
                                                'Video' :
                                                'Audio' }} call</div>
                                    <b-button variant="cta" size="lg" class="mt-5 mr-3" squared
                                        @click="openIcsModal()">Add to calendar</b-button>
                                    <b-button variant="cta-outline" size="lg" class="mt-5" squared
                                        @click="$router.push('/gp')">View
                                        your appointments</b-button>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="next-container h-100">
                                <h3>What happens next</h3>
                                <div class="d-flex flex-column">
                                    <div class="numbered-row d-flex flex-row align-items-start">
                                        <div class="mr-4 h-100 d-flex flex-grow">
                                            <i class="fa-solid fa-circle  brand-primary"></i>
                                            <span class="circle-number" style="left: 10px;">1</span>
                                            <div class="connect-line">
                                            </div>
                                        </div>
                                        <div>
                                            <h4>Check your email</h4>
                                            <p>You'll get an email confirmation with your appointment details. Check
                                                your junk or spam folder just in case.</p>
                                        </div>
                                    </div>
                                    <div class="numbered-row d-flex flex-row align-items-start">
                                        <div class="mr-4">
                                            <i class="fa-solid fa-circle  brand-primary"></i>
                                            <span class="circle-number">2</span>
                                            <div class="connect-line">
                                            </div>
                                        </div>
                                        <div>
                                            <h4>Bring ID to your appointment</h4>
                                            <p>Be ready to show the clinician a form of ID at the start of the
                                                appointment. For example, a passport or driving license.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="numbered-row d-flex flex-row align-items-start">
                                        <div class="mr-4">
                                            <i class="fa-solid fa-circle  brand-primary"></i>
                                            <span class="circle-number">3</span>
                                        </div>
                                        <div>
                                            <h4>Join your appointment</h4>
                                            <p>Join your appointment in My Bupa five minutes before it’s due to start.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row  justify-content-center pt-5" style="height: 80vh" v-else>
            <b-spinner class="brand-primary mt-5" />
        </div>
        <b-modal id="ics-modal" v-bind:modal-class="'ics-modal ' + getTheme()" hide-footer hide-header centered>
            <div class="d-flex flex-row justify-content-end">
                <span class="close-button mr-2" @click="$bvModal.hide('ics-modal')"><i
                        class="fas fa-times brand-highlight-1"></i></span>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center w-100">
                <h3 class="section-title mt-3">Download calendar invite (.ics)</h3>
                <p class="brand-text p-text">Check your downloads folder and open the file to save this appointment</p>
                <div class="d-flex flex-row justify-content-start align-items-center">
                    <b-button variant="cta" class="mr-3" @click="generateIcs()" squared>Add to calendar
                        (download)</b-button>
                    <b-button variant="cta-outline" @click="$bvModal.hide('ics-modal')" squared>Close</b-button>

                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import * as ics from 'ics'
import { saveAs } from 'file-saver';
import { ref } from 'vue';
import axios from "axios";
import config from "../config/constants";
import slick from "vue-slick";
import ErrorModal from "../components/GP/ErrorModal.vue";
import moment from "moment";


export default {
    name: "GpSelect",
    components: {
        slick,
        ErrorModal,
    },
    data() {
        return {
            apptTypeNames: {
                gp: "GP",
                physio: "physio",
                anp: "advanced nurse",
                mh: "mental health practitioner"
            },
            loading: true,
            bookedAppointmentType: null,
            selectedView: "appointmentType",
            selectedDeliveryType: null,
            selectedGenderType: null,
            selectedDate: null,
            selectedFilter: 'morning',
            selectedClinician: null,
            selectedTimeslot: null,
            dates: [],
            clinicians: [],
            timeslots: [],
            gpOverride: false,
            hasGp: false,
            timeslotsLoading: true,
            appointmentLoading: false,
            noDates: false,
            userDetails: { symptoms: '', photos: [] },
            genderOptions: [
                { value: "m", text: "Male" },
                { value: "f", text: "Female" },
                { value: "a", text: "Any" }
            ],
            slickOptions: {
                infinite: false,
                autoplay: false,
                dots: false,
                nextArrow:
                    '<div class="h-100 slack-arrow-container-right2">' +
                    '<button class=" bg-brand-primary slick-arrow mx-3" type="button" style="border-radius: 50%"><i class="fas fa-chevron-right text-white fa-2xs"></i></button>' +
                    '</div>',
                prevArrow:
                    '<div class="h-100 slack-arrow-container-left2">' +
                    '<button class=" bg-brand-primary slick-arrow mx-3" type="button" style="border-radius: 50%"><i class="fas fa-chevron-left text-white fa-2xs"></i></button>' +
                    '</div>',
                slidesToScroll: 7,
                slidesToShow: 7,
                centerPadding: "10",
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        },
                    }
                ],
            },
        };
    },
    mounted() {
        this.getUserCollection();
        let self = this;
        let weekStart = moment().startOf('day');
        let endWeek = moment().endOf('week').add(28, 'd');
        this.selectedDate = moment().startOf('day');
        let days = [];
        while (weekStart <= endWeek) {
            days.push(weekStart.toDate());
            weekStart = weekStart.clone().add(1, 'd');
        }
        this.dates = days;
        if (this.$route.query?.selectedTimeslotId) {
            this.selectedDate = this.$route.query?.selectedDate;
            this.selectedGenderType = this.$route.query?.selectedGenderType;
            this.selectedDeliveryType = this.$route.query?.selectedDeliveryType;
            this.selectedFilter = this.$route.query?.selectedFilter;
            this.getTimeslots().then(() => {

                this.selectedTimeslot = this.timeslots.find(x => x.id === self.$route.query.selectedTimeslotId);
                this.getUserDetails().then(() => {
                    this.selectedView = 'preview';
                    this.loading = false;
                });
            });
        } else {
            this.getBookings();
            this.loading = false;
        }
    },
    methods: {
        openIcsModal() {
            this.$bvModal.show('ics-modal');
        },
        getEndTime(booking) {
            let time = moment(booking.id);
            if (this.bookedAppointmentType === 'gp') {
                time.add(10, 'm');
            } else if (this.bookedAppointmentType === 'anp') {
                time.add(15, 'm');
            } else {
                time.add(20, 'm');
            }
            return time.format('h.mma');
        },
        generateIcs() {
            let duration;
            if (this.$route.params.appt_type === 'gp') {
                duration = 10;
            } else if (this.$route.params.appt_type === 'anp') {
                duration = 15;
            } else {
                duration = 20;
            }
            const startTime = moment(this.selectedTimeslot.id).format('YYYY,MM,DD,HH,mm').split(",");
            const start = startTime.map(Number);

            //generate event start time here.
            ics.createEvent({
                title: 'Bupa digital appointment',
                description: `How do I join my appointment?
We recommend joining your appointment five minutes before it's due to start. Make sure you're in a quiet, private space with an internet connection. We also recommend your device has enough battery life for up to a 20-minute call.

Confirming your identity
If you've not already had an ID check through the My Bupa app, we'll confirm your identity at the start of your appointment.

What if there's a technical issue?
If you get disconnected or have a poor signal, the clinician will call you instead using the phone number on your digital account

If you have any issues joining your appointment please call 0345 608 0898 - we may record or monitor our calls

If you need any additional support please email a member of the support team at bluaGP@bupa.com

How do I cancel or change my appointment?
You can cancel your appointment online or in the My Bupa app if you can no longer make it. To rearrange, you'll need to cancel and book again.`,
                busyStatus: 'BUSY',
                start: start,
                duration: { minutes: duration }
            }, (error, value) => {
                if (error) {
                    console.log(error)
                }
                const blob = new Blob([value], { type: 'text/calendar' });
                console.log(blob);
                saveAs(blob, `BupaAppointment.ics`);
            })
        },
        goBack() {
            if (this.selectedView === 'appointmentType') {
                if (this.$route.query.qh) {
                    this.$router.push({ name: 'matchTech', query: { qh: this.$route.query.qh, appt_type: this.$route.query.appt_type, pathway: this.$route.query.pathway } })
                } else {
                    this.$router.push('/gp');
                }
            }
            if (this.selectedView === 'genderType') {
                this.selectedDeliveryType = null,
                    this.selectedView = 'appointmentType'
            }
            if (this.selectedView === 'appointmentSelect') {

                this.selectedTimeslot = null;
                this.selectedGenderType = null;
                this.timeslots = [];
                this.noDates = false;
                this.selectedView = 'genderType';
            }
            if (this.selectedView === 'preview') {
                this.selectedView = 'appointmentSelect';
            }
            this.scrollToRef();
        },
        agreeToWarning() {
            this.selectedView = 'appointmentType'
            this.scrollToRef();
        },
        selectDeliveryType(type) {
            this.selectedDeliveryType = type;
            this.selectedView = 'genderType'
            this.scrollToRef();
        },
        selectGenderType(type) {
            this.selectedGenderType = type;
            this.selectedView = 'appointmentSelect'
            this.getTimeslots();
            this.scrollToRef();
        },
        async selectConsentOption(consent) {
            let res = await axios.post(
                config.matchtech_api_env + "/quiz/answer-question",
                { "question_id": "DGB0051", "items": [{ "type": "radio", "value": consent, "target_id": null }] },
                this.matchTechOptions
            );
            if (res.data) {
                this.selectedView = 'preview'

            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        selectDate(date) {
            this.selectedDate = date;
            this.selectedTimeslot = null;
            this.getTimeslots();
        },
        selectTimeslot(time) {
            this.selectedTimeslot = time;
        },
        selectFilter(filter) {
            this.selectedFilter = filter;
        },
        viewPreview() {
            let self = this;
            this.scrollToRef();
            this.getUserDetails();
            this.$tag.event('booking_appointment_selected', {
                clinician_type: self.$route.params.appt_type,
                care_pathway: self.$route.params.pathway,
                U16_booking_flag: 'N',
            });
            this.selectedView = 'preview';
        },
        buttonDisabled(date) {
            let today = moment().format('YYYY-MM-DD')
            return moment(date).isBefore(today);
        },
        editDetails() {
            this.$router.push({ name: 'matchTech', query: { qh: this.$route.query.qh, appt_type: this.$route.query.appt_type, pathway: this.$route.query.pathway, selectedDate: this.selectedDate.toString(), selectedTimeslotId: this.selectedTimeslot.id, selectedDeliveryType: this.selectedDeliveryType, selectedGenderType: this.selectedGenderType, selectedFilter: this.selectedFilter } })
        },
        async getBookings() {
            let self = this;
            const payload = {
                user_id: this.$store.getters.user_id,
            };
            let res = await axios.post(
                config.api_env + "/application/api/u/gp/get-bookings",
                payload,
                config.options
            );
            if (res.data.success) {
                if (res.data.bookings.length > 1) self.openErrorModal("You're already booked in", "Go to your appointments area to manage your bookings", false, true);
            }
        },
        async getUserCollection() {
            let res = await axios.get(
                config.matchtech_api_env + "/quiz/get-user-collection",
                this.matchTechOptions
            );
            if (res.data) {
                if (res.data?.answers?.length > 0) {
                    const answers = res.data?.answers;
                    let gpAnswer = answers.find(obj => obj.id === 'DGB004');
                    if (gpAnswer && gpAnswer?.items?.length > 0) {
                        if (gpAnswer?.items[0]?.value === 'Yes') {
                            this.hasGp = true;
                        }
                    }
                }
            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        async getTimeslots() {
            this.timeslotsLoading = true;
            let payloadDate = this.selectedDate;
            const payload = {
                user_id: this.$store.getters.user_id,
                appt_type: this.$route.params.appt_type,
                appt_delivery: this.selectedDeliveryType,
                appt_clinician_sex: this.selectedGenderType,
                date_id: moment(payloadDate).format('YYYY-MM-DD'),
            };
            let res = await axios.post(
                config.api_env + "/application/api/u/gp/get-time-slots",
                payload,
                config.options
            );
            if (res.data.success) {
                let a = moment(this.selectedDate);
                let b = moment(payloadDate);
                this.gpOverride = res.data.gp_override;
                if (a.isSame(b, 'day')) {
                    this.timeslots = res.data.timeslots;
                    this.timeslotsLoading = false;
                };
            } else if (res.data.start_sso_login) {
                this.openErrorModal('Your session has expired', "Please log in and try again", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        async createAppointment() {
            let self = this;
            this.appointmentLoading = true;
            const payload = {
                user_id: this.$store.getters.user_id,
                appointment: this.selectedTimeslot.appointment,
                symptom_start_date: this.$route.params.appt_type === 'mh' ? false : this.symptomDate,
                auto_consent: true,
            };
            let res = await axios.post(
                config.api_env + "/application/api/u/gp/book-appointment",
                payload,
                config.options
            );
            if (res.data.success) {
                this.appointmentLoading = false;
                this.bookedAppointmentType = res.data.appointment_type;
                this.scrollToRef();
                this.selectedView = 'bookingConfirm';
                this.$tag.event('booking_confirmed', {
                    clinician_type: res.data.appointment_type,
                    care_pathway: self.$route.params.pathway,
                    booking_ID: res.data.booking_id,
                    U16_booking_flag: 'N',
                });
            } else if (res.data.start_sso_login) {
                this.openErrorModal('Your session has expired', "Please log in and try again", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again", true);
            } else {
                this.appointmentLoading = false;
                this.openErrorModal("Sorry, this appointment is no longer available", "Please choose another appointment");
                this.goBack();
            }
        },
        async getUserDetails() {
            let res = await axios.post(
                config.matchtech_api_env + "/quiz/final-profile-review",
                { appt_type: this.$route.query.appt_type },
                this.getMatchTechOptions()
            );
            if (res.status === 200) {
                this.userDetails = this.$route.query.appt_type === 'mh' ? false : res.data;
                this.loading = false;
                this.selectedView = 'preview';

            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        openErrorModal(title, error, redirect, goBack) {
            const content = this.$createElement(ErrorModal, { props: { title, error, redirect, goBack } })
            const skin = this.$store.getters.skin;
            let opts = {
                hideHeader: true,
                hideFooter: true,
                modalClass: "coach_modal theme-" + skin,
                size: "md",
                buttonSize: "sm",
                centered: true,
                contentClass: "coach_modal",
                id: 'error-modal'
            }
            return this.$bvModal.msgBoxOk(content, opts);
        },
    },
    watch: {
        // selectedView: function (view) {
        //     let self = this;
        //     let day = moment().day();
        //     let width = window.innerWidth;
        //     if (view === 'appointmentSelect') {
        //         this.$nextTick(() => {
        //             if(width < 786){
        //                     self.$refs.slickRef.goTo(day, true);
        //             }
        //         });
        //     }
        // }
    },
    computed: {
        filteredTimeslots() {
            const format = 'hh:mm';
            let beforeTime, afterTime;
            if (this.selectedFilter === 'morning') {
                beforeTime = moment('00:00:00', format);
                afterTime = moment('12:00:00', format);
            } else {
                beforeTime = moment('11:59:59', format);
                afterTime = moment('23:59:59', format);
            }
            const filtered = this.timeslots.filter((slot) => {
                let slotTime = moment(slot.label, format);
                return slotTime.isBetween(beforeTime, afterTime)
            });
            return filtered;
        },
        matchTechOptions() {
            return this.getMatchTechOptions();
        },
    },
};
</script>
<style lang="less">
#ics-modal.ics-modal {
    font-size: 1.6rem;

    .sentence-case::first-letter {
        text-transform: uppercase;
    }

    .modal-dialog {
        padding-bottom: 0 !important;
    }

    .modal-content {
        padding: 20px;
    }

    p {
        margin-bottom: 20px;
    }

    .section-title {
        font-size: 2rem;
        font-family: "Montserrat", serif;
        font-weight: 700;
        letter-spacing: 0;
        margin-bottom: 20px;
    }

    b {
        font-family: 'Montserrat', serif;
    }

    i {
        font-size: 2rem;
    }

    .fa-times {
        cursor: pointer;
    }
}

#GpSelect {
    font-family: "Montserrat", serif !important;
    background-color: #eee;

    .sentence-case::first-letter {
        text-transform: uppercase;
    }

    .back-button-container {
        padding-top: 80px;
        font-size: 1.4rem;
        font-weight: bold;
        font-family: 'Montserrat';
        font-weight: 700;

        .back-button {
            cursor: pointer;
        }
    }

    .shadow {
        box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);
    }

    .gp-select-container {
        min-height: 90vh;
    }

    .header-container {
        width: 100%;
        background-color: white;
        padding: 20px;
        border-radius: 16px;

        h2 {
            margin-top: 10px;
            text-align: left;
            font-size: 2rem;
            margin-bottom: 0;
            padding-bottom: 10px;
        }

    }

    @media screen and (max-width: 768px) {
        .column-row {
            flex-direction: column !important;
        }
    }

    .column-row {
        gap: 30px;
        display: flex;
        flex-direction: row;
    }

    .columns {
        flex: 100%;
    }



    .appointment-card {
        font-size: 1.6rem;
        padding: 20px;
        background-color: white;
        border-radius: 16px;

        h3 {
            font-size: 2.5rem;
            padding-top: 0;
            padding-bottom: 0;
            letter-spacing: normal;
            color: #212529;
        }

        h3:first-letter {
            text-transform: uppercase;
        }

        div {
            padding-bottom: 5px;
        }

        .appointment-card-details {
            border-top: 1px solid #ccc;

            h4 {
                font-family: "Montserrat", serif;
                padding-top: 15px;
                margin-bottom: 10px;
            }

            i {
                font-size: 1.6rem;
                padding-right: 10px;
            }

            div {
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }
    }

    .next-container {
        background-color: white;
        border-radius: 16px;
        padding: 20px;

        h3 {
            font-size: 1.6rem;
            text-align: left;
            margin-bottom: 0;
            padding-bottom: 15px;
        }

        @media screen and (max-width: 768px) {
            .connect-line {
                height: 60% !important;
            }
        }

        .connect-line {
            position: absolute;
            width: 2px;
            height: 60%;
            background: #DDE1E6;
            top: 30px;
            left: 10.5px;
            z-index: 10;
            border-radius: 16px;

        }

        .numbered-row {
            position: relative;
            margin-bottom: 5px;

            h4 {
                text-align: left;
                margin-bottom: 0px;
                padding-bottom: 5px;
                font-size: 1.4rem;
            }

            p {
                font-size: 1.4rem;
            }

            .circle-number {
                position: absolute;
                top: 3px;
                left: 9px;
                color: white;
                text-align: right;
                z-index: 10000;
                font-size: 1.2rem;
            }


            i {
                z-index: 1000;
                font-size: 2.4rem;
            }
        }
    }

    .prompt-info-container {
        display: flex;
        align-items: flex-start;
        font-family: "Montserrat", serif;
        font-weight: 700;
        background-color: white;
        padding: 20px;
        border: 2px solid #0279c8;
        border-radius: 16px;
        max-width: 700px;

        h3 {
            font-family: "Montserrat", serif;
            font-weight: 700;
            letter-spacing: normal;
            font-size: 1.6rem;
            padding: 0;
            margin-bottom: 15px;
        }

        p {
            font-weight: normal;
            font-size: 1.4rem;
            text-align: left;
        }
    }

    .type-select-button {
        cursor: pointer;
        letter-spacing: normal !important;
        background-color: white;
        display: flex;
        flex-grow: 1;
        width: 100%;
        padding: 20px 40px;
        margin-top: 20px;
        font-size: 1.6rem;
        display: flex;
        flex-direction: row;
        text-align: left;
        align-items: center;
        font-family: "Montserrat", serif;
        font-weight: 700;
        color: #0079c8;
        border-radius: 6px;

        .fa-solid {
            font-size: 6rem;
            color: #0079c8;
        }

        &:hover {
            background-color: #0079c8;
            color: white;

            i {
                color: white;
            }
        }
    }

    .active {
        background-color: #0079c8;
        color: white;
        border: 2px solid #0079c8;

        i {
            color: white;
        }
    }

    .available-times-header {
        font-size: 1.6rem;
        color: #aaa;
        font-weight: normal;
        margin-bottom: 0;
        padding-bottom: 15px;
    }

    .available-times-header {
        font-size: 1.6rem;
        color: #aaa;
        font-weight: normal;
        margin-bottom: 0;
        padding-bottom: 15px;
    }

    .warning-container {
        max-width: 600px;
        font-size: 1.6rem;

        h3 {
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
            font-size: 1.8rem;
        }

        .warning-info-container {
            font-family: "Montserrat", serif;
            font-weight: 700;
            background-color: white;
            padding: 20px;
            border: 2px solid #D60023;
            border-radius: 16px;
            margin-bottom: 25px;

            i {
                color: #D60023;
            }
        }

        .btn {
            margin-top: 30px;
            margin-bottom: 100px;
        }
    }

    .booking-confirm-container {
        padding-top: 100px;
    }


    .slick-container {
        width: 100%;
    }

    .slick-button {
        width: 100%;
    }

    .booking-button {
        min-width: 200px !important;
    }


    .btn.btn-cta {
        &:hover {
            background-color: #0079c8 !important;
        }
    }

    .slick-next {
        right: -30px;
        top: 23px;
    }

    .slick-prev {
        left: -25px;
        top: 23px;
    }

    .VueCarousel-navigation-button {
        font-size: 15px;
        color: #0079c8;
        top: 18px;
    }

    .slick-slide {
        transform: scale(1) !important;
    }

    .container-width {
        max-width: 450px;
    }

    .booking-container-width {
        max-width: 700px;
    }

    .btn {
        min-width: 100px;
        margin-bottom: 10px;
    }

    .timeslot-button {
        color: #21272A;
    }

    .btn-cta {
        color: white;
    }

    .selected-date {
        background-color: #0079c8;
        color: white;

        &:hover {
            background-color: #0079c8;
            color: white;
        }
    }

    .no-appointments {
        font-size: 1.6rem;
    }

    .no-appointments-text {
        padding-top: 25px;
        font-size: 1.6rem;
    }

    .slick-class {
        width: calc(100% - 60px);
        margin: 0 auto;
    }

    .slick-arrow {
        padding: 0;
        display: flex;
        align-items: center;
    }

    .slack-arrow-container-right2 {
        background-color: rgba(255, 255, 255, 0) !important;
        right: -45px !important;
        width: 50px !important;
    }

    .slack-arrow-container-left2 {
        background-color: rgba(255, 255, 255, 0) !important;
        left: -45px !important;
        width: 50px !important;
    }

    .slick-disabled {
        .bg-brand-primary {
            background-color: #ccc !important;
        }
    }

    .brand-text {
        font-size: 1.6rem;
    }

    .tc-link {
        color: #0079c8;
        text-decoration: underline;
    }

    b {
        font-family: 'Montserrat', serif;
        font-weight: 700;
    }

    h3 {
        font-family: 'Montserrat', serif !important;
        font-weight: bold;
        padding-top: 0;
        margin-top: 0;
        letter-spacing: normal;
        text-align: center;
    }

    h3,
    h4 {
        color: #21272A !important;
    }

    .no-appointments {
        font-size: 1.6rem;
    }

    .no-appointments-text {
        padding-top: 25px;
        font-size: 1.6rem;
    }

    .phone-text {
        color: inherit !important;
        font-family: 'Montserrat', serif !important;
        font-weight: 700 !important;
    }

    .fa-4x {
        color: green;
    }

    .review-details {
        width: 100%;

        .text-prompt-container {
            max-width: 700px;
            font-size: 1.6rem;

            h3 {
                padding-top: 0;
                margin-top: 0;
                letter-spacing: normal;
                font-size: 1.8rem;
            }

            .details-container {
                width: 100%;
                background-color: white;
                border: 1px solid #dde1e6;

                .details-row {
                    border-bottom: 1px solid #dde1e6;
                    padding: 20px;
                    word-wrap: break-word;
                    text-align: left;

                    .details-row-title {
                        font-weight: 500;
                        margin-bottom: 0;
                        padding-bottom: 0;
                    }

                    .edit-button {
                        align-self: start;
                        cursor: pointer;
                        font-weight: bold;
                    }
                }
            }
        }

        .preview-image {
            max-width: 150px;
            min-width: 150px;
            min-height: 150px;
            max-height: 150px;
            object-fit: scale-down;
            border-radius: 16px;
            background-color: #eee;
        }

    }

    #BookingSelection {
        width: 100%;
        max-width: 100%;
        font-size: 1.6rem;

        h3 {
            font-family: 'Montserrat', serif !important;
            font-weight: bold;
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
        }

        .button-group {
            border: 1px solid #0079c8;
            border-radius: 5px;
            background-color: white;
        }

        .date-selector-container {
            min-width: 100%;
            background-color: white;
            border-radius: 12px;
            padding: 20px;
            width: 100%;
        }

        .date-select-button {
            background-color: white;
            cursor: pointer;
            padding: 10px;
            font-size: 1.8rem !important;
            border: 1px solid white;
            color: #0079c8;
            border-radius: 8px;

            &:hover {
                background-color: #eee;
                border: 1px solid #eee;
            }

            .month-class {
                font-size: 1.4rem;
                color: #ccc;
            }
        }

        .date-select-button:disabled,
        .date-select-button[disabled] {
            cursor: not-allowed;
            background-color: white;
            padding: 10px;
            font-size: 1.8rem !important;
            border: 1px solid white;
            border-radius: 8px;
            color: #ccc;

            &:hover {
                border: 1px solid white;
            }
        }

        .timeslot-button {
            color: #21272A;
            border: 1px solid #0079c8;
        }

        .btn-cta {
            color: white;
        }

        .selected-date {
            background-color: #0079c8;
            color: white;

            &:hover {
                background-color: #0079c8;
                color: white !important;
            }
        }

        .no-appointments {
            font-size: 1.6rem;
        }

        .no-appointments-text {
            padding-top: 25px;
            font-size: 1.6rem;
        }

        .slick-class {
            width: calc(100% - 60px);
            margin: 0 auto;
        }

        .slick-arrow {
            border-width: 0 !important;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            color: #fff;
            font-size: 3rem;
            height: 40px;
            width: 40px;
            padding: 0;
            line-height: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            text-align: center;

            &:focus {
                outline: none;
            }

            &.slick-next {
                right: 0;
            }
        }

        .slack-arrow-container-right {
            background-color: rgba(255, 255, 255, 0.8) !important;
            right: -45px !important;
            width: 50px !important;
        }

        .slack-arrow-container-left {
            background-color: rgba(255, 255, 255, 0.8) !important;
            left: -45px !important;
            width: 50px !important;
        }

        .slick-disabled {
            .bg-brand-primary {
                background-color: #ccc !important;
            }
        }
    }

}
</style>